//@ts-check

class IncomeStatementService {
	constructor($http, Utility, $timeout, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	async init() {
		this.incomeStatementData = undefined;
	}

	async getIncomeStatement(schemeRef, date) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('FinancialApiIncomeStatement');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiIncomeStatement');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();
			const headers = this.Utility.headersWithContentType;


			if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
				const error = `Could not load Levy as the 'Username' and/or 'Session Token' is missing`;
				this.$timeout(() => promiseHandler.reject(error));
			}

			const results = await this.$http.post(url, date, { headers: headers });
			const { data } = results;
			this.incomeStatementData = data;
			this.$timeout(() => promiseHandler.resolve());
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(`Error fetching Income Statement Data`, err));
		}

		return promise;
	}
}

export default /* @ngInject */ ($http, Utility, $timeout, LocalStorageService, InternalLinksService) =>
	new IncomeStatementService($http, Utility, $timeout, LocalStorageService, InternalLinksService);
